// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3WBkT","box":"WorkspacesBox_box__14_h3","node":"WorkspacesBox_node__35jTy"};